/**
 * axios 配置
 */
import Vue from "vue";
import axios from "axios";
import qs from "qs";
import { Message, Loading } from "element-ui";
import { baseIp } from "../service/apis";
import { baseUrl } from '@/service/apis'
import { fishSysBaseUrl } from '@/config/urlConfig'
import { createDebounce } from '@/pages/tablePanels/ship/shipMethods/shipLayer'
// 响应时间
axios.defaults.timeout = 100 * 1000;
// 配置cookie
// axios.defaults.withCredentials = true
//配置跨域
// axios.defaults.withCredentials = true
// axios.defaults.crossDomain = true
// 配置请求头
axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded,application/xml;charset=UTF-8";
// 静态资源
Vue.prototype.$static = "";
let _this = new Vue();

// 配置接口地址
axios.defaults.baseURL = "";
var loadingInstance;
let loadText = "";

const initLoading = (loading = {}) => {
    if (loading) {
        _this.$loading.show();
    }
};
const loadingClose = () => {
    _this.$loading.close();
};
let debounce = createDebounce(1000)

function logout() {
    debounce(() => {
        Vue.prototype.$bus.$emit("logout")
    })
}
// POST传参序列化(添加请求拦截器)
axios.interceptors.request.use(
    (config) => {
        // 渔业资源的接口需要加权限

        if (config.url.search(baseIp) != -1 || config.url.search('http://140.210.143.5:8080') != -1) {
            const token = localStorage.getItem("token")
            if (token) {
                config.headers.Authorization = token
            }
        }
        if(config.url.includes(fishSysBaseUrl)){
            console.log('用到渔业接口',config.url)
        }
        // _this.$loading.show();
        // if (loadText !== "") {
        //   loadingInstance = Loading.service({
        //     lock: true,
        //     text: loadText === undefined ? "数据加载中，请稍后..." : loadText,
        //     spinner: "el-icon-loading",
        //     background: "rgba(0, 0, 0, .1)",
        //   });
        // }

        // if (config.method === 'post') {
        //     config.data = qs.stringify(config.data)
        // }
        // config.headers.common.Accept = "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;image/png";
        return config;
    },
    (err) => {
        // debugger
        loadingClose()
            // loadingInstance ? (loadingInstance ? loadingInstance.close() : "") : "";
            // Message.error('请求错误')
        return Promise.reject(err);
    }
);
// 返回状态判断(添加响应拦截器)
axios.interceptors.response.use(
    (res) => {
        // debugger
        if (
            true
            // res.code === 0 ||
            // res.data.code == 0 ||
            // res.data.Collections ||
            // res.data.success === true ||
            // res.data.CODE === "1" ||
            // res.data.CODE === "2" ||
            // res.data.code === "1" ||
            // res.data.code === 1 ||
            // res.data.code === "2" ||
            // res.data.length >= 0 ||
            // res.data.status === "ok" ||
            // res.data instanceof Blob ||
            // res.data.data.code === "1" ||
            // res.status == 200
        ) {
            loadingClose()
            if (!res.data || parseInt(res.data.code) == 10020) {
                // 强制下线不返回数据
                logout()
            }
            return res;
        } else {
            loadingClose()
            Message.error(res.data.msg);
        }
    },
    (err) => {
        // debugger
        loadingClose()
            // Message.error('请求失败，请稍后再试')
        return Promise.reject(err);
    }
);
// 发送请求
export function fetchPost(url, params, config, loading) {
    initLoading(loading)
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, config)
            .then(
                (res) => {
                    resolve(res.data);
                    loadingClose()
                },
                (err) => {
                    reject(err.data);
                    loadingClose()
                }
            )
            .catch((err) => {
                reject(err.data);
                loadingClose()
            });
    });
}
export function fetchGet(url, params, loading, config) {
    initLoading(loading)
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
            }, config)
            .then((res) => {
                resolve(res.data);
                loadingClose()
            })
            .catch((err) => {
                reject(err.data);
                loadingClose()
            });
    });
}
/**
 * 
 * @param {*} url 地址
 * @param {*} file 文件
 * @param {*} data 附加数据
 * @returns {Promise} Promise
 */
export function postFile(url, file, data) {
    initLoading()
    let fmd = new FormData()
    fmd.append('file', file)
    if (data) {
        for (let k of Object.keys(data)) {
            fmd.append(k, data[k])
        }
    }
    return new Promise((resolve, reject) => {
        axios.post(url, fmd, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        }).finally(() => {
            loadingClose()
        })
    })
}
export function obj2Form(obj) {
    let form = new FormData()
    for (let k in obj) {
        form.append(k, obj[k])
    }
    return form
}
export function postForm(url, params, loading,config={}) {
    if (!(params instanceof FormData)) {
        params = obj2Form(params)
    }
    initLoading(loading)
    return new Promise((resolve, reject) => {
        axios
            .post(url, params,config)
            .then((res) => {
                resolve(res.data);
                loadingClose()
            })
            .catch((err) => {
                reject(err.data);
                loadingClose()
            });
    });
}
export function fetchGetImg(url, params, loading) {
    initLoading(loading)
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
                responseType: "blob",
                headers: {
                    "Content-Type": "image/png",
                },
            })
            .then((res) => {
                resolve(res.data);
                loadingClose()
            })
            .catch((err) => {
                reject(err.data);
                loadingClose()
            });
    });
}

export function fetchPostImg(url, params, loading) {
    loadText = text;
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                responseType: "blob",
                // headers: {
                //     'Content-Type': 'image/png'
                // }
            })
            .then(
                (res) => {
                    resolve(res.data);
                    loadingClose()
                },
                (err) => {
                    reject(err.data);
                    loadingClose()
                }
            )
            .catch((err) => {
                reject(err.data);
                loadingClose()
            });
    });
}


// WEBPACK FOOTER //
// ./src/config/axiosConfig.js